import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, vendorLabel } from "../lib/api";
import ProductCard from "../components/ProductCard";

const TAGLINES = {
  bundles: "The smartest way to buy — every vendor's full list in one drop.",
  electronics: "Full AirPods / iPhone / MacBook / Apple Watch list — all in one bundle.",
  meta_glasses: "Every Ray-Ban Meta colorway. AI, camera, open-ear audio built in.",
  dyson: "Airwrap, Supersonic, V15 — the cult-classic lineup.",
  clothing: "Essentials, Stüssy, ALD, Kith. Streetwear staples.",
  shoes: "Deadstock sneakers, Sambas, Dunks, NB. Box fresh.",
  designer: "Margiela, Bottega, Prada, Saint Laurent, Loewe — apparel + footwear.",
  accessories: "Sunglasses, bags, wallets, belts, watch bands.",
  jewelry: "Chains, hoops, rings, demi-fine pieces.",
  cologne: "Niche & designer fragrance — Creed, Tom Ford, Dior, Le Labo, PdM, Xerjoff.",
};

export default function Category() {
  const { vendor } = useParams();
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const r = await api.get(`/products`, { params: { vendor } });
      setItems(r.data);
    })();
  }, [vendor]);

  return (
    <div data-testid={`category-${vendor}`} className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <Link to="/catalog" data-testid="back-to-catalog" className="overline hover:text-white">← Catalog</Link>
      <div className="mt-6 flex items-end justify-between flex-wrap gap-6">
        <div>
          <div className="overline mb-3">Vendor</div>
          <h1 className="font-serif italic text-5xl md:text-7xl tracking-tighter">{vendorLabel(vendor)}</h1>
          <p className="text-white/50 max-w-xl mt-4">{TAGLINES[vendor]}</p>
        </div>
        <div className="text-white/40 text-sm">{items.length} pieces</div>
      </div>

      <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12">
        {items.map((p, i) => (
          <ProductCard key={p.id} product={p} idx={i} />
        ))}
      </div>
    </div>
  );
}
